import {createStyles, Theme} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {PausedStatusBackground, PausedStatusColor} from "../patient-status-badge/patient-status-badge.style";

//  Banner colours follow the new Orpyx portal: enrolled/active read as
//  informational, paused as a warning and discontinued as an error
export const EnrolledStatusBackground = '#E6EDFB';
export const EnrolledStatusColor = '#2F58A8';

export const ActiveStatusBackground = '#E4F4EC';
export const ActiveStatusColor = '#1B7A4B';

export const DiscontinuedStatusBackground = '#FCE3E5';
export const DiscontinuedStatusColor = '#C62B39';

export const PatientStatusBannerStyle = createStyles({
    banner: {
        padding: '8px 16px',
        textAlign: 'center',
        textTransform: 'uppercase',
        fontSize: '14px',
        fontWeight: 700,
        letterSpacing: '0.5px',
        borderRadius: '4px',
    },
    enrolled: {
        backgroundColor: EnrolledStatusBackground,
        color: EnrolledStatusColor,
    },
    active: {
        backgroundColor: ActiveStatusBackground,
        color: ActiveStatusColor,
    },
    paused: {
        backgroundColor: PausedStatusBackground,
        color: PausedStatusColor,
    },
    discontinued: {
        backgroundColor: DiscontinuedStatusBackground,
        color: DiscontinuedStatusColor,
    },
});

export const usePatientStatusBannerStyle = makeStyles((theme: Theme) => PatientStatusBannerStyle);
